import axiosInstance from '../configs/axios/interceptors';

const DivisionsServices = {

    getDivisions: async (appliedFilters) => {
        const params = { divisionName: appliedFilters.divisionName };
        const response = await axiosInstance.get('Division/GetDivisionsList', { params: params });
        return response.data;
    },

    createDivision: async (payload) => {
        const response = await axiosInstance.post('Division/AddDivision', payload);
        return response.data;
    },

    updateDivision: async (payload) => {
        const response = await axiosInstance.put('Division/UpdateDivision', payload);
        return response.data;
    }
};

export default DivisionsServices;